function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Evented from './Evented';
export var Metrics = /*#__PURE__*/function (_Evented) {
  _inheritsLoose(Metrics, _Evented);

  function Metrics() {
    var _this;

    _this = _Evented.apply(this, arguments) || this;
    _this.backends = new Map();
    return _this;
  }

  var _proto = Metrics.prototype;

  _proto.registerHost = function registerHost(host, options) {
    var _this2 = this;

    var backendInfo = "" + (options.ssl ? 'secure:' : 'insecure') + options.host;
    host.on('up', function () {
      return _this2.emit('up', backendInfo);
    });
    host.on('down', function () {
      return _this2.emit('down', backendInfo);
    });
    host.on('heartbeat', function () {
      return _this2.emit('heartbeat', backendInfo);
    });
    this.backends.set(backendInfo, host);
  };

  _proto.generate = function generate() {
    var out = {};
    this.backends.forEach(function (host, key) {
      out[key] = host.metrics;
    });
    return out;
  };

  return Metrics;
}(Evented);